<template>
	<section>
		<el-card class="table-card">
			<el-table
				:data="paginatedServiceMaintenanceData"
				v-loading="loading"
				element-loading-text="loading..."
				stripe
				border
				style="width: 100%"
                :row-class-name="tableRowClassName"
			>
				<el-table-column prop="sort_order" :label="$t('serviceMaintenance.sort')"></el-table-column>

				<el-table-column prop="type" :label="$t('serviceMaintenance.type')">
	                <template slot-scope="scope">
                    	{{ scope.row.type === TypeEnum.SERVICE ? $t("serviceMaintenance.service") : $t("serviceMaintenance.soft") }}
                    </template>
                </el-table-column>

				<el-table-column prop="app_name" :label="$t('serviceMaintenance.applicationName')"></el-table-column>
				<el-table-column prop="merchant_name" :label="$t('serviceMaintenance.businessName')"></el-table-column>
               	<el-table-column prop="details_zh" :label="$t('serviceMaintenance.introduction')"></el-table-column>
               	<el-table-column prop="listing_time" :label="$t('serviceMaintenance.latestShelvesTime')">
                    <template slot-scope="scope">
                        {{ scope.row.listing_time ? formatUtcToLocal(scope.row.listing_time) : "" }}
                    </template>
                </el-table-column>

			</el-table>

			<div class="pagination-container" v-if="!loading && totalRecords > 0">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalRecords"
					background
				></el-pagination>
			</div>
		</el-card>

	</section>
</template>

<script>
import { formatUtcToLocal } from "@/utils/date";

const TypeEnum = {
	SERVICE:1,// 1代表服务，2代表软件
	SOFT:2,
};

export default {
	name: "ServiceProviderList",

    props: {
        serviceProviderData: {
            type: Array,
            default: () => []
        },
        loading: Boolean,
    },

    	data() {
		return {
            TypeEnum,

			allServiceMaintenanceData: [], // 缓存所有数据
			serviceMaintenanceData: [], // 当前页的数据
			currentPage: 1,
			pageSize: 20,
			totalRecords: 0,
		};
	},

    watch: {
        serviceProviderData: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.allServiceMaintenanceData = newVal;
                    this.totalRecords = newVal.length;
                    this.updateCurrentPageData();
                } else {
                    this.allServiceMaintenanceData = [];
                    this.totalRecords = 0;
                    this.serviceMaintenanceData = [];
                }
            },
            immediate: true
        }
    },

	methods: {
		formatUtcToLocal,

         isInLastSevenDays(dateString) {

            if (!dateString) return false;

            const dataUtcToLocal=formatUtcToLocal(dateString)

            const inputDate = new Date(dataUtcToLocal);
            const currentDate = new Date();

            // 将当前日期设为当天的23:59:59，输入日期设为当天的00:00:00以便比较
            const startOfCurrentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const startOfInputDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());

            // 计算两个日期之间的天数差异
            const timeDifference = startOfCurrentDay.getTime() - startOfInputDay.getTime();
            const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

            // 如果差异在7天内（包括当天），返回true
            return daysDifference <= 7 && daysDifference >= 0;
        },

        // 根据最新上架时间判断是否为最近7天内，需要高亮显示
        tableRowClassName({ row }) {
            if (this.isInLastSevenDays(row.listing_time)) {
                return 'highlight-row';
            }
            return '';
        },

        // 计算当前页的数据
        updateCurrentPageData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.serviceMaintenanceData = this.allServiceMaintenanceData.slice(start, end);
        },

		handleCurrentChange(page) {
			this.currentPage = page;
			this.updateCurrentPageData();
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
			this.updateCurrentPageData();
		},
	},

    computed: {
        // 添加一个计算属性，用于获取当前页的数据
        paginatedServiceMaintenanceData() {
            return this.serviceMaintenanceData;
        }
    }
};
</script>
<style scoped>
.table-card {
	margin-top: 20px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
	margin-top: 20px;
	text-align: right;
}
/* 禁用交互 */
.readonly-checkbox-group {
	pointer-events: none;
	opacity: 1 !important;
}

/* 设置表格所有行的背景为白色 */
::v-deep .el-table .el-table__body-wrapper tbody tr td {
    background-color: white !important;
}

/* 高亮行保持黄色背景 */
::v-deep .el-table .el-table__body tr.highlight-row td {
    background-color: #FFFACD !important;
}

/* 覆盖hover效果 */
::v-deep .el-table .el-table__body tr:hover > td {
    background-color: #f5f7fa !important;
}

/* 针对高亮行的hover效果 */
::v-deep .el-table .el-table__body tr.highlight-row:hover td {
    background-color:  #ffff00c0 !important;
}
</style>